import { useShowWeaveDesignLab } from "@design-lab/shared/lib/config";
import type { Tab } from "./state";

/**
 * Hook to determine artboard visibility based on current tab and WeaveDesignLab experiment
 * @param tab - Current active tab
 * @returns Object with boolean flags for component logic
 */
export function useArtboardVisibility(tab: Tab) {
  const shouldShowWeaveDesignLab = useShowWeaveDesignLab();
  const isUploadTab = tab === "upload";
  const shouldHideArtboard = shouldShowWeaveDesignLab && isUploadTab;

  return {
    shouldShowWeaveDesignLab,
    isUploadTab,
    shouldHideArtboard
  };
}
